export const modelscopeModels = {
    id: "modelscope",
    name: "ModelScope",
    api: "https://api-inference.modelscope.cn/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://modelscope.cn/docs/model-service/API-Inference/intro",
    env: ["MODELSCOPE_API_KEY"],
    models: {
        "Qwen/Qwen3-30B-A3B-Thinking-2507": {
            id: "Qwen/Qwen3-30B-A3B-Thinking-2507",
            name: "Qwen3 30B A3B Thinking 2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-30",
            last_updated: "2025-07-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 32768,
            },
        },
        "Qwen/Qwen3-Coder-480B-A35B-Instruct": {
            id: "Qwen/Qwen3-Coder-480B-A35B-Instruct",
            name: "Qwen3-Coder-480B-A35B-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "Qwen/Qwen3-235B-A22B-Thinking-2507": {
            id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
            name: "Qwen3-235B-A22B-Thinking-2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "Qwen/Qwen3-30B-A3B-Instruct-2507": {
            id: "Qwen/Qwen3-30B-A3B-Instruct-2507",
            name: "Qwen3 30B A3B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-30",
            last_updated: "2025-07-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 16384,
            },
        },
        "Qwen/Qwen3-235B-A22B-Instruct-2507": {
            id: "Qwen/Qwen3-235B-A22B-Instruct-2507",
            name: "Qwen3 235B A22B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-07-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "Qwen/Qwen3-Coder-30B-A3B-Instruct": {
            id: "Qwen/Qwen3-Coder-30B-A3B-Instruct",
            name: "Qwen3 Coder 30B A3B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-31",
            last_updated: "2025-07-31",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 65536,
            },
        },
        "ZhipuAI/GLM-4.5": {
            id: "ZhipuAI/GLM-4.5",
            name: "GLM-4.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 98304,
            },
        },
        "moonshotai/Kimi-K2-Instruct": {
            id: "moonshotai/Kimi-K2-Instruct",
            name: "Kimi-K2-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
    },
};
export default modelscopeModels;
//# sourceMappingURL=modelscope.js.map